<template>
  <div class="JoinUs">
    <div class="main">
      <p class="title">加入我们</p>
      <img class="img" :src="imgurl" />
      <p class="text">大数据正在改变着商业游戏规则，为企业解决传统业务问题带来了变革的机遇，</p>
      <p class="text">我们的使命是帮助更多企业创造无限商业价值，</p>
      <p class="text">加速推动互联网大数据的商业变革。</p>

      <p class="remark">加入我们，一起推动和见证大数据带来的精彩变革！</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JoinUs',
  data () {
    return {
      imgurl: require("@/assets/imgs/img-activity.png")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  .JoinUs {

    .main {
      width: 1200px;
      margin: 0 auto;
      padding: 35px 0;
      p {
        text-align: center;
      }
      .title {
        font-size:40px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        margin-bottom: 30px;
      }
      .img {
        width: 1052px;
        height: 579px;
        display: block;
        margin: 0 auto 30px;
      }
      .text {
        font-size:20px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:42px;
      }

      .remark {
        font-size:30px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:42px;
        margin-top: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact_Us/JoinUs.vue